import { render, staticRenderFns } from "./addDiscussion.vue?vue&type=template&id=e0433392&scoped=true"
import script from "./addDiscussion.vue?vue&type=script&lang=js"
export * from "./addDiscussion.vue?vue&type=script&lang=js"
import style0 from "./addDiscussion.vue?vue&type=style&index=0&id=e0433392&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0433392",
  null
  
)

export default component.exports